import React from 'react';
import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Selectors
import * as GoalsSelectors from 'Shared/selectors/Goals.selectors';

// Types
import { User, GoalItem } from 'Shared/constants/types';

// Hooks
import { useGoalDetailPanel } from 'Shared/utils/hooks/use-goal-detail-panel';

// Components
import UserGoalsContainer from 'Shared/components/Goals/UserGoalsContainer';
import GoalsCardContainer from 'Shared/components/Goals/GoalsCardContainer/GoalsCardContainer';
import GoalsTable from 'Shared/components/Goals/GoalsTable/GoalsTable';

type Props = {
  user: User;
  isViewingComplete?: boolean;
  workspaceSlug: string;
  isPersonal?: boolean;
};

const OneOnOneAndTeamSyncUserGoals = ({ user, isViewingComplete, workspaceSlug, isPersonal }: Props) => {
  const { featureFlagGoalsVersion3: showNewGoals } = useFlags();

  const { handleOpenPanel } = useGoalDetailPanel();

  const goals = useSelector(state =>
    GoalsSelectors.getGoalsForWorkspace(state, {
      userId: user.id,
      complete: isViewingComplete,
      workspaceSlug,
      privacySetting: 'everyone',
    })
  )
    .valueSeq()
    .toJS();

  const handleClick = (goal: GoalItem) => {
    handleOpenPanel(goal.slug);
  };

  return (
    <div className="WorkspaceUserGoals">
      {isPersonal ? (
        <div className="pt-4">
          {showNewGoals ? <GoalsTable goals={goals} onRowClick={handleClick} /> : <GoalsCardContainer goals={goals} />}
        </div>
      ) : (
        <UserGoalsContainer user={user} goals={goals} />
      )}
    </div>
  );
};

export default OneOnOneAndTeamSyncUserGoals;
